export const SIZES = {
  large: 'large',
  medium: 'medium',
  small: 'small',
  extraLarge: 'extra-large',
};
